import React, { useState, useEffect, useCallback, useContext } from "react";

import "App.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import default_dish_img from "images/svg_dishes/pot-dinner-svgrepo-com.svg";
import { Box, Typography } from "@mui/material";
import isPhotoUrl from "helpers/isPhotoUrl";
import changeSize from "helpers/changeSize";
import { CartContext } from "App";

export function CardColumn({ food, quantity, style }) {
  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = useState(false);
  const {
    title,
    image,
    price,
    description,
    translations,
    translations_descriptions,
  } = food;

  const { language,settings } = useContext(CartContext);

  const { t } = useTranslation();

  const handleClick = () => {
    console.log("food handleClick :>> ", food);
    navigate("/product", { state: { food } });
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <Box
      className="CardColumn"
      onClick={handleClick}
      style={{
        "display": "flex",
        "flexDirection": "row",
        "alignItems": "center",
        "padding": "0px 0px 7px 7px",
        "margin": "5px",
        "border": "1px solid   #e0c521",
        "borderRadius": "7px",
        "cursor": "pointer",
        "transition": "background-color 0.3s",
        "position": "relative",
        "&:hover": {
          backgroundColor: "#f0f0f0",
        },
        ...style,
      }}
    >
      {quantity > 0 && (
        <span
          className="card_badge"
          style={{
            fontSize: "0.9rem",
            position: "absolute",
            top: "10px",
            right: "10px",
            // backgroundColor: "#009de0",
            color: "white",
            borderRadius: "30%",
            padding: "2px 6px",
            zIndex: 1,
          }}
        >
          {quantity}
        </span>
      )}
      <Box
        style={{
          flex: "0 0 60%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingRight: "10px",
        }}
      >
        <Typography
          variant="subtitle1"
          style={{ marginBottom: "2px", fontSize: "1rem", fontWeight: "bold" }}
        >
          {translations && translations[language]
            ? translations[language]
            : title}
        </Typography>
        <Typography
          variant="body2"
          style={{
            color: "gray",
            fontSize: "0.8rem",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            marginTop: "5px",
          }}
        >
          {translations_descriptions && translations_descriptions[language]
            ? translations_descriptions[language]
            : description}
        </Typography>
        <Typography
          variant="body2"
          style={{ marginBottom: "2px", fontSize: "0.9rem", color: "#009de0" }}
        >
          {price}{settings?.currency?.symbol ? ' ' + settings.currency.symbol : ''}
        </Typography>
      </Box>

      <Box
        className="image_container"
        style={{
          display: imageLoaded ? "block" : "none",
          aspectRatio: "1/1",
          flexShrink: 0,
          position: "relative",
        }}
      >
        <img
          src={isPhotoUrl(image) ? changeSize(image) : default_dish_img}
          alt={title}
          onLoad={handleImageLoad}
          style={{
            display: "block",
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>
    </Box>
  );
}
